module.exports = __webpack_public_path__ + "img/recent-changes.1915053b.svg";